import apiService from '../apiService'

const apiPath = '/auth-dealer';

export const adController = (configService = {}) => {
  const service = apiService(configService);
  return {
    updateADInfo: (params) => {
      return service.put(`${apiPath}`, params)
    },
    updateTermsAndCondition: (params) => {
      return service.put(`${apiPath}/terms/update`, params)
    },
    getMultipleLocation:() => {
      return service.get(`${apiPath}/multiple-location`)
    },
    updateSelectLocation: (params) => {
      return service.put(`${apiPath}/multiple-location/update`, params)
    },
  }
}
